import { AnswerType, ICategory } from "../models";

export const round95: ICategory[] = [
	{
		id: "1qxjj4uk1scgk09",
		name: "Name That Port",
		answers: [
			{
				id: "1qxjj4uk1scgk0e",
				type: AnswerType.TEXT,
				answer: "443",
				question: "What is HTTPS?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0j",
				type: AnswerType.TEXT,
				answer: "22",
				question: "What is SSH?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0o",
				type: AnswerType.TEXT,
				answer: "3306",
				question: "What is MySQL?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0t",
				type: AnswerType.TEXT,
				answer: "445",
				question: "What is SMB (or CIFS)?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0y",
				type: AnswerType.TEXT,
				answer: "3389",
				question: "What is Remote Desktop Protocol (RDP)?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj4uk1scgk0a",
		name: "Hello World",
		answers: [
			{
				id: "1qxjj4uk1scgk0f",
				type: AnswerType.TEXT,
				answer: "",
				question: "What is Python?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0k",
				type: AnswerType.TEXT,
				answer: "",
				question: "What is Java?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0p",
				type: AnswerType.TEXT,
				answer: "",
				question: "What is JavaScript?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0u",
				type: AnswerType.TEXT,
				answer: "",
				question: "What is Go?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0z",
				type: AnswerType.TEXT,
				answer: "",
				question: "What is C#?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj4uk1scgk0b",
		name: "Web Acroynms",
		answers: [
			{
				id: "1qxjj4uk1scgk0g",
				type: AnswerType.TEXT,
				answer: "WWW",
				question: "What is 'World Wide Web'?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0l",
				type: AnswerType.TEXT,
				answer: "HTTP",
				question: "What is 'Hypertext Transfer Protocol'?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0q",
				type: AnswerType.TEXT,
				answer: "CSS",
				question: "What is 'Cascading Style Sheets'?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0v",
				type: AnswerType.TEXT,
				answer: "TLS",
				question: "What is 'Transport Layer Security'?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk10",
				type: AnswerType.TEXT,
				answer: "CORS",
				question: "What is 'Cross Origin Resource Sharing'?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj4uk1scgk0c",
		name: "Hacker Crews",
		answers: [
			{
				id: "1qxjj4uk1scgk0h",
				type: AnswerType.TEXT,
				answer: "Cyper, Thank, Switch, Trinity, Morpheus, Neo",
				question: "What is 'The Matrix'?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0m",
				type: AnswerType.TEXT,
				answer: "Eliot Anderson, Darlene, Tyrell Wellick, fsociety",
				question: "What is 'Mr. Robot'?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0r",
				type: AnswerType.TEXT,
				answer: "The Plague, Phantom Phreak, Crash Override, Zero Cool, Acid Burn",
				question: "What is 'Hackers'?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0w",
				type: AnswerType.TEXT,
				answer: "Batou, Togusa, Saito, Ishikawa, Motoko ('The Major')",
				question: "What is 'Ghost in the Shell'?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk11",
				type: AnswerType.TEXT,
				answer: "Count Zero, Brian Oblivion, Space Rogue, Kingpin, Mudge",
				question: "What is L0pht?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	},
	{
		id: "1qxjj4uk1scgk0d",
		name: "Famous Hacks",
		answers: [
			{
				id: "1qxjj4uk1scgk0i",
				type: AnswerType.TEXT,
				answer:
					"Film studio that was allegedly hacked for making a movie about North Korean leader Kim Jong-Un",
				question: "What is Sony?",
				explanation: "",
				points: 100,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0n",
				type: AnswerType.TEXT,
				answer:
					"This adult infidelity site had its user list released after refusing to shut down.",
				question: "What is Ashley Madison?",
				explanation: "",
				points: 200,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0s",
				type: AnswerType.TEXT,
				answer:
					"This credit agency was hacked and 149 million Americans' personal information was leaked",
				question: "What is Equifax?",
				explanation: "",
				points: 300,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk0x",
				type: AnswerType.TEXT,
				answer:
					"This retail chain was breached through a 3rd party HVAC system's credentials and lost 41 million customers' credit card information",
				question: "What is Target?",
				explanation: "",
				points: 400,
				show: false,
				answered: false
			},
			{
				id: "1qxjj4uk1scgk12",
				type: AnswerType.TEXT,
				answer:
					"Probably the most publicized nation state cyberattack, this worm was designed to destroy nuclear reactors and was unleashed against Iran",
				question: "What is Stuxnet?",
				explanation: "",
				points: 500,
				show: false,
				answered: false
			}
		]
	}
];
